// extracted by mini-css-extract-plugin
module.exports = {"mobileTitle":"ListeProduits_mobileTitle__6Q3Tf","photo":"ListeProduits_photo__6NijV","nom":"ListeProduits_nom__2-M-X","big":"ListeProduits_big__1aPWg"};